import { HttpClient } from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';

@Injectable()
export class MetricApi extends BaseApi {
    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getUserGrowthExcel(){
        return this.http.get(this.baseUri + '/metric/usergrowth/', {
            responseType: 'blob'
        });
    }
}